<template>
	<v-tooltip bottom :open-on-hover="!!tooltipText">
		<template v-slot:activator="{ on }">
			<v-btn
				v-on="{...on,click:onClick}"
				v-bind="$attrs"
			>
				<slot></slot>
			</v-btn>
		</template>
		<span>{{tooltipText}}</span>
	</v-tooltip>
</template>

<script>
	export default {
		name: "c-btn",
		props: {
			data: {required: false, default: null},
			options: {
				type: Object, default: () => {
					return {};
				}
			},
			tooltipText: {default: "מחיקה"}
		},
		components: {},
		data() {
			return {};
		},
		computed: {},
		methods: {
			onClick() {
				this.$emit("click", this.data);
			}
		},
		watch: {},
		created() {
		},
		mounted() {
		},
		updated() {
		},
		destroyed() {
		}
	};
</script>

<style scoped>

</style>
